import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { InvoicesState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const invoiceModule: Module<InvoicesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
